const autoNgTemplateLoaderTemplate1 = require('./entity-profile.template.html');
const autoNgTemplateLoaderTemplate2 = require('./entity-profile.template.html');
const autoNgTemplateLoaderTemplate3 = require('./entity-profile.template.html');

'use strict';

import { NAVIGATION_ICON } from '../../modules/shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../../modules/shared/constants/user-info/solutionType';

(function () {
    angular
        .module('app.entityProfile', [])
        .config(entityProfileConfig);

    entityProfileConfig.$inject = ['$routeProvider'];

    function entityProfileConfig($routeProvider) {
        $routeProvider
            .when('/nutrition/entity-profile/:id', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'EntityProfileController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.NUTRITION,
                    breadcrumbs: [
                        { label: 'Entity Profile', icon: NAVIGATION_ICON.WORK }
                    ]
                }
            })
            .when('/scan-iq/entity-profile/:id', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate2,
                controller: 'EntityProfileController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.SCAN_IQ,
                    breadcrumbs: [
                        { label: 'Entity Profile', icon: NAVIGATION_ICON.WORK }
                    ]
                }
            })
            .when('/entity-profile', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate3,
                controller: 'EntityProfileController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: null,
                    breadcrumbs: [
                        { label: 'Entity Profile', icon: NAVIGATION_ICON.WORK }
                    ]
                }
            })
    }
})();
